import { useNavigate } from 'react-router-dom';
import DashboardComponent from '../../components/adminDashboard/dashboardComponent';
import { DriversSection } from '../../components/adminDashboard/driversSection';
import { LeasedCarsSection } from '../../components/adminDashboard/leasedCarsSection';
import { OrderedCarsSection } from '../../components/adminDashboard/orderedCarsSection';
import { PAGES, ROLESLIST } from '../../config/constants';
import { LifebuoyIcon } from '../../icons/lifebuoyIcon';
import usePersonStore from '../../store/personStore';
import Container from '../../components/elements/container';

export const AdminDashboard = () => {
  const navigate = useNavigate();

  const userData = usePersonStore((store) => store.userData);
  const pageAccess = usePersonStore((store) => store.pageAccess); // authData
  const userRoles = usePersonStore((store) => store.userRoles); // authData

  const hasAdminRole = userData && userData.isAdmin;
  const {
    USERS,
    ROLES,
    REPORTS,
    INVOICES,
    IMPORT_DRIVERS,
    MY_CAR,
    DOWNLOAD_LOGS,
    OFFER_CHECK,
    OFFERS_REPORTING,
    BOOKING_REPORTS,
    TRACK_YOUR_CAR,
    GROUP_OF_COMPANIES,
  } = PAGES;

  const { CONTRACTCENTER } = ROLESLIST;

  return (
    <Container className="py-6 flex flex-col gap-6 scrollbar max-lg:px-5">
      <div className="w-full flex justify-between items-center">
        <h2>{!userData.companyGroupMemberCompany ? userData.name ?? '' : userData.companyGroupMemberCompany}</h2>
        <button
          className="flex gap-3 cursor-pointer"
          onClick={() => navigate('/faqs')}
        >
          <LifebuoyIcon />
          <p className="text-subtitle max-lg:hidden">Κέντρο Υποστήριξης</p>
        </button>
      </div>
      <div className="grid lg:grid-cols-3 gap-6">
        {pageAccess.includes(MY_CAR) && (
          <div className="lg:col-span-3">
            <LeasedCarsSection />
          </div>
        )}
        {(pageAccess.includes(TRACK_YOUR_CAR) ||
          userRoles.includes(CONTRACTCENTER)) && (
          <div className="lg:col-span-2 h-full">
            <DriversSection className="bg-transparent lg:bg-white" />
          </div>
        )}
        {pageAccess.includes(TRACK_YOUR_CAR) && (
          <div className="col-span-1 h-full">
            <OrderedCarsSection />
          </div>
        )}
      </div>
      <div
        className={`grid ${
          hasAdminRole ? 'lg:grid-cols-3 sm:grid-cols-2' : 'lg:grid-cols-2'
        } gap-6`}
      >
        <DashboardComponent
          access={USERS}
          pageAccess={pageAccess}
          pageName={USERS}
        />
        <DashboardComponent
          access={ROLES}
          pageAccess={pageAccess}
          pageName={ROLES}
        />
        <DashboardComponent
          access={USERS}
          pageAccess={pageAccess}
          pageName={IMPORT_DRIVERS}
        />
        <DashboardComponent
          access={OFFER_CHECK}
          pageAccess={pageAccess}
          pageName={OFFER_CHECK}
        />
        <DashboardComponent
          access={OFFERS_REPORTING}
          pageAccess={pageAccess}
          pageName={OFFERS_REPORTING}
        />
        <DashboardComponent
          access={DOWNLOAD_LOGS}
          pageAccess={pageAccess}
          pageName={DOWNLOAD_LOGS}
        />
        <DashboardComponent
          access={BOOKING_REPORTS}
          pageAccess={pageAccess}
          pageName={BOOKING_REPORTS}
        />
        <DashboardComponent
          access={INVOICES}
          pageAccess={pageAccess}
          pageName={'Invoice'}
        />
        <DashboardComponent
          access={REPORTS}
          pageAccess={pageAccess}
          pageName={'Reports'}
        />
        <DashboardComponent
          access={GROUP_OF_COMPANIES}
          pageAccess={pageAccess}
          pageName={GROUP_OF_COMPANIES}
        />
      </div>
    </Container>
  );
};
